<template>
  <div>
    <div class="loginWrap" :class="{miniWrap: platform}">
      <div class="login-content">
        <div class="close-btn" @click="hiddenLogin"></div>
        <h2>登录饷店</h2>
        <div class="login-wrap">
          <div class="item">
            <input v-model="phone" type="text" maxlength="11" placeholder='请输入手机号码（该手机号为后期登录饷店使用）' @input="inputing">
          </div>
          <div class="item">
            <input class="code" v-model="code" type="text" maxlength="6" placeholder='请输入验证码' @input="inputing">
            <div class="btn-code" @click="sendSms" v-show="codeStatus">{{codeMsg}}</div>
            <div class="btn-code disabled" v-show="!codeStatus">{{time}}s</div>
          </div>
          <div class="error-msg">{{errorMsg}}</div>
          <div class="btn-login" :class="{active: loginBtn}" @click="login" v-show="loginBtn">登录</div>
          <div class="btn-login" v-show="!loginBtn">登录</div>
          <p class="agree">登录即表示您同意<em @click="userRule">《用户服务协议》</em>和<em @click="jumpPolicy">《隐私政策》</em></p>
        </div>

        <div class="openedTip" v-show="showOpenTip">你已开通饷店，自动为你跳转店主后台...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { xdSms, xdLogin, xdRefreshToken, xdHasShop } from 'api/http'
export default {
  name: 'login',
  data() {
    return {
      phone: '',
      code: '',
      time: 60,
      codeStatus: true,
      loginBtn: false,
      errorMsg: '',
      codeMsg: '获取验证码',
      showOpenTip: false
    }
  },
  created() {
    this.$track.sendLog('pageview', {
      spm: '3.1604'
    })
  },
  computed: {
    ...mapState([
      'platform'
    ])
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setLoginWrap']),
    inputing() {
      let phone = this.phone
      const reg = /^1\d{10}$/;
      if (reg.test(phone) && this.code && this.code.length === 6) { 
        this.loginBtn = true
      }else {
        this.loginBtn = false
      }
      this.errorMsg = '';
    },
    jumpPolicy(){
      console.log(1111111);
      let url = window.location.protocol + '//' + window.location.host + '/policy'
      window.open(url, "_blank")
    },
    userRule() {
      this.$track.sendLog('click', {
        spm: '3.1604.1793'
      })
      let url = window.location.protocol + '//' + window.location.host + '/rules'
      window.open(url, "_blank")
    },
    hiddenLogin() {
      this.setLoginWrap(false)
    },
    async sendSms() {
      this.$track.sendLog('click', {
        spm: '3.1604.1794'
      })
      let that = this
      let phone = this.phone
      const reg = /^1\d{10}$/;
      if (!reg.test(phone)) {
        this.$Message.error("手机号码有误，请重新输入");
        return false;
      }

      // 开通了饷店（购买的饷店在有效期内）、跳转到饷团官网 ----2019-09-27新增逻辑by 陈小飞
      let opened = await xdHasShop({mobile: phone}).catch(er=> {
        console.log('xdSms', er)
      })
      if(opened.success && opened.data) {
        let redirectUri = process.env.NODE_ENV == 'production' ? 'https://console.xiangtuan.xyz/login?loginType=msg' : 'http://msbackend-test1.akucun.com/login?loginType=msg'
        this.showOpenTip = true
        setTimeout(()=> {
          this.showOpenTip = false
          window.location.href = redirectUri
        }, 1500)
        return
      }

      this.codeStatus = false;
      let timer = setInterval(() => {
        that.time--;
        if (that.time <= 0) {
          that.codeStatus = true
          that.codeMsg = '重新获取'
          that.time = 60;
          clearInterval(timer)
        }
      }, 1000)

      const res = await xdSms({mobile: phone}).catch(er=> {
        console.log('xdSms', er)
        that.codeStatus = true
      })

      if(res.code == 0 && res.success) {
        this.$Message.loading("短信发送中...");
      }else {
        this.$Message.warning(res.message);
        that.codeStatus = true
      }
    },
    async login() {
      this.$track.sendLog('click', {
        spm: '3.1604.1792'
      })
      let phone = this.phone
      const reg = /^1\d{10}$/;
      if (!reg.test(phone)) {
        this.$Message.error("手机号码有误，请重新输入");
        return false;
      }
      let code = this.code
      const res = await xdLogin({mobile: phone, smsCode: code}).catch(er=> {
        console.log('xdLogin', er)
      })

      if(res.code == 0 && res.success) {
        const { userId='', userName='',userLevel } = res.data
        localStorage.setItem('akc_userId', userId)
        localStorage.setItem('akc_userPhone', phone)
        localStorage.setItem('akc_userName', userName)
        localStorage.setItem('akc_vip_level', userLevel)
        this.setUserInfo({
          userId: userId,
          userPhone: phone,
          userName: userName
        })
        this.$Message.success("登录成功");
        this.errorMsg = '';
        this.setLoginWrap(false)
        this.refreshToken(userId)
      }else {
        this.errorMsg = res.message
        this.$Message.warning(res.message);
      }
    },
    async refreshToken(userId){
      const res = await xdRefreshToken({userId: userId}).catch(er=> {
        console.log('xdRefreshToken', er)
      })
      if(res.code == 0 && res.success) {
        const { imLoginId='', token='' } = res.data
        localStorage.setItem('akc_akid', imLoginId)
        localStorage.setItem('akc_token', token)
      }else {
        this.$Message.warning(res.message);
      }
    }
  }
}
</script>

<style scoped lang="less">
  .loginWrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(51,51,51,.7);
    .login-content {
      width: 420px;
      height: 362px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 2px;
      .close-btn {
        height: 20px;
        width: 20px;
        background-image: url('../common/img/close.png');
        background-size: 100% 100%;
        position: absolute;
        top: 17px;
        right: 17px;
        cursor: pointer;
      }
      h2 {
        font-size:24px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:rgba(51,51,51,1);
        line-height:33px;
        padding: 40px 0 17px 0;
      }
      .login-wrap {
        width: 300px;
        margin: 0 auto;
        .item {
          width: 100%;
          position: relative;
          input {
            border: none;
            border-bottom: solid 1px #E6E6E6;
            line-height: 20px;
            padding: 20px 0 4px;
            width: 100%;
            font-size: 12px;
          }
          .btn-code {
            position: absolute;
            top: 20px;
            right: 0;
            color: #EC2232;
            font-size:14px;
            font-family:PingFangSC-Regular;
            line-height: 20px;
            cursor: pointer;
            &.disabled {
              color: #999;
              cursor: default;
            }
          }
          em {
            font-style: normal;
          }
        }
        .error-msg {
          padding: 24px 0 9px 0;
          font-size:12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(236,34,50,1);
          line-height:17px;
          text-align: left;
          height: 50px;
        }
        .btn-login {
          height:44px;
          background:#EC2232;
          border-radius:4px;
          opacity:0.3;
          line-height: 44px;
          color: #fff;
          cursor: pointer;
          &.active {
            opacity:1;
            &:hover {
              background: #FC3142;
            }
          }
        }
        .agree {
          font-size:12px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:17px;
          margin-top: 8px;
          em {
            color:#EC2232;
            font-style: normal;
            cursor: pointer;
          }
        }
      }
      .openedTip {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        background: rgba(0, 0, 0, .6);
        border-radius: 3px;
        color: #fff;
        font-size: 12px;
        width: 252px;
        line-height: 32px;
      }
    }
  }
</style>
